import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  // comentario: Yup.string()
  //   .min(3)
  //   .max(500)
  //   .notRequired(),
  // titulo: Yup.string()
  //   .min(3)
  //   .max(15)
  //   .required()
})
